<template>
  <section class="section reveal-section" id="programas" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Formación Integral</span>
      <h2 class="section-title">Nuestros Programas</h2>
      <p class="section-subtitle">Diseñados para equipar y transformar cada área de tu vida</p>
    </div>
    <div class="programs-grid">
      <ion-card v-for="(program, index) in programs" :key="index" class="program-card">
        <div class="icon" :style="{ background: program.color }">
          <i :class="program.icon"></i>
        </div>
        <ion-card-header>
          <ion-card-title style="font-family:'League Spartan';font-size:1.4rem;color:var(--vh-azul-profundo)">{{ program.title }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <p>{{ program.description }}</p>
        </ion-card-content>
      </ion-card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))

const programs = ref([
  { title: 'Escuela de Formación', description: 'Cursos bíblicos y de liderazgo para fortalecer tu fe y desarrollar tu potencial ministerial.', icon: 'fas fa-book-open', color: 'var(--vh-azul-cielo)' },
  { title: 'Grupos de Vida', description: 'Comunidades pequeñas donde crecemos juntos en relación, cuidado mutuo y propósito.', icon: 'fas fa-users', color: 'var(--vh-dorado)' },
  { title: 'Acción Social', description: 'Proyectos comunitarios que generan impacto real en las necesidades de nuestra ciudad.', icon: 'fas fa-hand-holding-heart', color: 'var(--vh-verde)' },
  { title: 'Generación Joven', description: 'Espacios creativos y seguros donde los jóvenes descubren su identidad y llamado.', icon: 'fas fa-child', color: 'var(--vh-rosa)' }
])
</script>

<style scoped>
.section { padding: 7rem 5%; }
.programs-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 2rem; max-width: 1200px; margin: 0 auto; }
.program-card {
  background: white; border-radius: 16px; padding: 2.5rem 2rem;
  box-shadow: 0 4px 20px var(--vh-sombra); transition: all 0.3s;
  border-top: 4px solid transparent; position: relative; overflow: hidden;
}
.program-card::before {
  content: ''; position: absolute; top: -50%; right: -50%;
  width: 200%; height: 200%;
  background: radial-gradient(circle, rgba(251,166,54,0.1) 0%, transparent 70%);
  opacity: 0; transition: opacity 0.3s;
}
.program-card:hover { transform: translateY(-12px) scale(1.02); box-shadow: 0 20px 50px var(--vh-sombra); }
.program-card:hover::before { opacity: 1; }
.program-card:nth-child(1) { border-top-color: var(--vh-azul-cielo); }
.program-card:nth-child(2) { border-top-color: var(--vh-dorado); }
.program-card:nth-child(3) { border-top-color: var(--vh-verde); }
.program-card:nth-child(4) { border-top-color: var(--vh-rosa); }
.icon {
  width: 60px; height: 60px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.5rem; color: white; margin-bottom: 1.5rem;
  position: relative; z-index: 2; animation: float 3s ease-in-out infinite;
}
ion-card-content p { color: #555; line-height: 1.7; position: relative; z-index: 2; }
</style>
